// extracted by mini-css-extract-plugin
export default {"widget":"TurnstileWidget_widget__UwdT1"};